module.exports = __webpack_public_path__ + "img/fans_message_img.a55afc9e.jpeg";